import Chat from '@sats-group/icons/24/comment';
import Mail from '@sats-group/icons/24/mail';
import Phone from '@sats-group/icons/24/phone';
import Button from '@sats-group/ui-lib/react/button';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Message from '@sats-group/ui-lib/react/message';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import KindlyChat from '~/client/components/kindly-trigger/kindly-trigger';
import MessagingTrigger from '../messaging-trigger/messaging-trigger';
import RichText from '../rich-text/rich-text';
import type { ContactUs as Props } from './contact-us.types';
import ContactUsItem from './contact-us-item';

const ContactUs: React.FunctionComponent<Props> = ({
  chat,
  form,
  message,
  mode,
  phone,
  title,
}) => (
  <>
    {chat || form || phone ? (
      <div className="contact-us">
        <Text
          elementName="h2"
          theme={Text.themes.emphasis}
          size={Text.sizes.headline3}
        >
          {title}
        </Text>
        {message ? (
          <div className={'contact-us__message'}>
            <Message {...message} />
          </div>
        ) : null}
        <div className="contact-us__items">
          {chat?.variant === 'kindly' && chat.key ? (
            <>
              <KindlyChat botKey={chat.key} language={chat.language} />

              <ContactUsItem
                actions={
                  <Button
                    id="kindly-bot-trigger-chat"
                    variant={Button.variants.secondary}
                    text={chat.triggerText}
                  />
                }
                defaultOpen
                icon={<Chat />}
                id="contact-us__chat"
                text={
                  chat.operationsInformation ? (
                    <RichText {...chat.operationsInformation} />
                  ) : undefined
                }
                title={chat.title}
              />
            </>
          ) : null}

          {chat?.variant === 'messaging' ? (
            <ContactUsItem
              actions={
                chat.messagingTrigger ? (
                  <MessagingTrigger {...chat.messagingTrigger} />
                ) : (
                  <React.Fragment />
                )
              }
              defaultOpen={mode !== 'closed'}
              icon={<Chat />}
              id="contact-us__chat"
              text={
                chat.operationsInformation ? (
                  <RichText {...chat.operationsInformation} />
                ) : undefined
              }
              title={chat.title}
            />
          ) : null}
          {form ? (
            <ContactUsItem
              actions={
                <LinkButton
                  {...form.link}
                  variant={LinkButton.variants.secondary}
                />
              }
              defaultOpen={mode !== 'closed'}
              icon={<Mail />}
              id="contact-us__form"
              text={<Text>{form.formDescription}</Text>}
              title={form.title}
            />
          ) : null}

          {phone ? (
            <ContactUsItem
              actions={
                phone.phoneNumber ? (
                  <LinkButton
                    href={`tel:${phone.phoneNumber}`}
                    text={phone.phoneNumber}
                    variant={LinkButton.variants.secondary}
                  />
                ) : undefined
              }
              defaultOpen={false}
              icon={<Phone />}
              id="contact-us__phone"
              text={
                phone.operationsInformation ? (
                  <RichText {...phone.operationsInformation} />
                ) : undefined
              }
              title={phone.title}
            />
          ) : null}
        </div>
      </div>
    ) : null}
  </>
);

export default ContactUs;
